<template>
    <svg width="546" height="334" viewBox="0 0 546 334" fill="none" class="resource-page__shape" aria-hidden="true">
        <path
            d="M187.29 29.7294C196.59 9.00738 181.108 -1.6813 167.949 -7.58836L43.6555 -63.4096C30.5 -69.3198 12.2234 -73.7903 2.92039 -53.0715C-6.38259 -32.3495 9.10279 -21.6608 22.2615 -15.7537L146.555 40.0675C159.711 45.9778 177.987 50.4482 187.29 29.7294Z"
            class="resource-page__shape__1"
        />
        <path
            d="M249.201 55.7882C265.404 32.9517 249.233 16.32 234.733 6.02636L75.4435 -107.149C60.944 -117.442 39.9098 -127.223 23.7065 -104.389C7.50338 -81.5528 23.675 -64.9212 38.1744 -54.6275L197.464 58.5476C211.964 68.8413 232.998 78.6215 249.201 55.7882Z"
            class="resource-page__shape__2"
        />
        <path
            d="M343.403 130.859C385.767 104.7 370.811 66.2498 354.199 39.338L197.278 -214.894C180.67 -241.802 152.999 -272.409 110.639 -246.25C68.275 -220.092 83.2312 -181.641 99.8426 -154.73L256.764 99.5029C273.371 126.411 301.039 157.017 343.399 130.859L343.403 130.859Z"
            class="resource-page__shape__3"
        />
        <path
            d="M412.126 248.937C485.175 238.659 487.758 177.58 481.232 131.171L419.571 -307.217C413.044 -353.618 393.708 -411.613 320.663 -401.335C247.614 -391.057 245.031 -329.978 251.558 -283.568L313.219 154.82C319.745 201.22 339.081 259.216 412.126 248.942L412.126 248.937Z"
            class="resource-page__shape__4"
        />
        <path
            d="M463.746 326.474C541.279 345.033 568.028 284.625 579.813 235.37L691.139 -229.93C702.924 -279.181 706.411 -345.16 628.882 -363.72C551.349 -382.279 524.6 -321.871 512.814 -272.616L401.489 192.684C389.703 241.935 386.217 307.914 463.746 326.474Z"
            class="resource-page__shape__5"
        />
    </svg>
</template>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .resource-page__shape {
        position: absolute;
        top: 0;
        right: 0;
        height: 300px;

        @include mq.screen_md(min) {
            height: calc(100% - var(--joy-core-spacing-12));
            width: auto;
        }

        /* Themes */
        .resource-page--default & {
            &__1 {
                fill: var(--joy-color-primary-70);
            }

            &__2 {
                fill: var(--joy-color-primary-10);
            }

            &__3 {
                fill: var(--joy-color-brand-primary-30);
            }

            &__4 {
                fill: var(--joy-color-quaternary-50);
            }

            &__5 {
                fill: var(--joy-color-primary-50);
            }
        }

        .resource-page--corporate & {
            &__1 {
                fill: var(--joy-color-primary-70);
            }

            &__2 {
                fill: var(--joy-color-primary-30);
            }

            &__3 {
                fill: var(--joy-color-primary-90);
            }

            &__4 {
                fill: var(--joy-color-primary-70);
            }

            &__5 {
                fill: var(--joy-color-primary-50);
            }
        }

        .resource-page--strategy & {
            &__1 {
                fill: var(--joy-color-secondary-50);
            }

            &__2 {
                fill: var(--joy-color-tertiary-70);
            }

            &__3 {
                fill: var(--joy-color-neutral-30);
            }

            &__4 {
                fill: var(--joy-color-tertiary-70);
            }

            &__5 {
                fill: var(--joy-color-secondary-30);
            }
        }
    }
</style>
